// Owner-identity check. Owner-only controls render for the owner email OR any admin
// account (is_admin) — consistent with the /admin route and header OWNER badge.
export const OWNER_EMAIL = "rmctech101@gmail.com";

export function isOwner(user) {
  if (!user) return false;
  if (user.is_admin) return true;
  return (user.email || "").trim().toLowerCase() === OWNER_EMAIL;
}
